import { EMOJI_CATEGORY_TITLES } from './constants';
import triumphantLogo from '../Assets/newsie-triumphant-192-removebg.png';
import sadLogo from '../Assets/sad-newsie-192-removebg.png';

const CARD_SIZE = 600;
const CORRECT_COLOR = '#20e277';
const INCORRECT_COLOR = '#ff7575';
const FONT_STACK = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

const loadImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

const drawSquare = (ctx: CanvasRenderingContext2D, x: number, y: number, size: number, color: string) => {
  ctx.fillStyle = color;
  if (typeof (ctx as any).roundRect === 'function') {
    ctx.beginPath();
    (ctx as any).roundRect(x, y, size, size, 8);
    ctx.fill();
  } else {
    ctx.fillRect(x, y, size, size);
  }
};

export const generateShareCardBlob = async ({
  won,
  score,
  incorrectGuesses,
  category,
  date,
  guessSequence = [],
  streak,
}: {
  won: boolean;
  score: number;
  incorrectGuesses: number;
  category: string;
  date?: string;
  guessSequence?: boolean[];
  streak?: number;
}): Promise<Blob> => {
  const canvas = document.createElement('canvas');
  canvas.width = CARD_SIZE;
  canvas.height = CARD_SIZE;
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

  ctx.fillStyle = '#eef1f8';
  ctx.fillRect(0, 0, CARD_SIZE, CARD_SIZE);

  try {
    const logo = await loadImage(won ? triumphantLogo : sadLogo);
    ctx.drawImage(logo, CARD_SIZE / 2 - 50, 40, 100, 100);
  } catch {
    // logo failed to load - card still works without it
  }

  ctx.textAlign = 'center';
  ctx.fillStyle = '#1e1b4b';
  ctx.font = `bold 36px ${FONT_STACK}`;
  ctx.fillText('Daily Newsie', CARD_SIZE / 2, 175);

  const [label, emoji] = EMOJI_CATEGORY_TITLES[category] || ['Newsie', '🗞️'];
  ctx.font = `24px ${FONT_STACK}`;
  ctx.fillStyle = '#6b7094';
  ctx.fillText(`${emoji || ''} ${label}${date ? ' · ' + date : ''}`, CARD_SIZE / 2, 215);

  const squareSize = 50;
  const gap = 10;
  if (guessSequence.length) {
    const totalWidth = guessSequence.length * squareSize + (guessSequence.length - 1) * gap;
    let x = CARD_SIZE / 2 - totalWidth / 2;
    const y = 260;
    guessSequence.forEach((correct) => {
      drawSquare(ctx, x, y, squareSize, correct ? CORRECT_COLOR : INCORRECT_COLOR);
      x += squareSize + gap;
    });
  }

  ctx.font = `bold 30px ${FONT_STACK}`;
  ctx.fillStyle = '#1e1b4b';
  const outcomeLine = won ? `Score: ${score}` : `Gave up after ${incorrectGuesses} guesses`;
  ctx.fillText(outcomeLine, CARD_SIZE / 2, 365);

  if (streak && streak > 1) {
    ctx.font = `22px ${FONT_STACK}`;
    ctx.fillStyle = '#5b3df0';
    ctx.fillText(`🔥 ${streak}-day streak`, CARD_SIZE / 2, 405);
  }

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Failed to generate share card'));
    }, 'image/png');
  });
};
